import { jwtDecode } from "jwt-decode";
import { dicNames } from "../lang/i18n";
import UserDataModel from "../store/UserData/UserDataModel";
import log from "loglevel";
const Cookies = require("js-cookie");

export function appRefreshAndUpdate() {
    if ('serviceWorker' in navigator) {
        navigator.serviceWorker
            .getRegistration()
            .then((reg: any) => {
                reg.waiting.postMessage({ type: 'SKIP_WAITING' });
                window.location.reload();
            })
            .catch((err) => console.log('Could not get registration: ', err));
    }
}

export default class Helpers {

    static Token: string = (Cookies.get('rosht') ? Cookies.get('rosht') : '')??'';

    public static UserGet() {
        if (Helpers.Token && Helpers.Token !== "") {
            try {
                const decoded: any = jwtDecode(Helpers.Token);
                if (Date.now() >= decoded.exp * 1000) {
                    Cookies.remove("rosht");
                }
                else
                    return decoded;
            } catch (e) {
                console.log(e);
            }
            return undefined;
        }
    }

    public static LocationFromPath(pathname: string): string {
        const paths = pathname.split('/')
        if (paths.length < 3) return ''
        switch (paths[2]) {
            case 'page':
            case 'user':
            case 'cart':
            case 'order':
            case 'pok':
                return '';
            default:
                return paths[2]
        }
    }
    public static PageReload(key: string) {
        if (key) {
            var ax = window.location.href.split('#');
            window.location.href = ax[0] + key;
        }
        window.location.reload();
    }

    public static PageChangeURL(page: string) {
        document.location.href = document.location.href.split('#')[0] + '#' + page;
    }

    public static ObjectToQueryString(params: any) {
        return Object.keys(params).map(key => params[key] ? key + '=' + params[key] : null).filter(Boolean).join('&');
    }

    static FormValidateEmail(email: string) {
        // eslint-disable-next-line
        const re = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
        return re.test(email);
    }

    public static FormValidate(form: any) {
        const arrElements = Array.prototype.slice.call(form.elements);
        let errors: any = { isValidated: true };
        for (let x = 0, xl = arrElements.length; x < xl; x++) {
            if (arrElements[x].name.length === 0) continue;
            arrElements[x].classList.remove('is-invalid');
            if (arrElements[x].required) {
                if (arrElements[x].value === '') {
                    arrElements[x].classList.add('is-invalid');
                    errors[arrElements[x].name] = true;
                    errors.isValidated = false;
                }
            }
            if (!errors[arrElements[x].name]) {
                var isValid = true;
                switch (arrElements[x].type) {
                    case 'email':
                        isValid = Helpers.FormValidateEmail(arrElements[x].value);
                        break;
                }
                if (arrElements[x].dataset.validate) {
                    switch (arrElements[x].dataset.validate) {
                        case 'password':
                            isValid = arrElements[x].value.length > 6;
                            break;
                    }
                }
                if (!isValid) {
                    arrElements[x].classList.add('is-invalid');
                    errors[arrElements[x].name] = true;
                    errors.isValidated = false;
                }
            }
        }
        return errors;
    }

    // used to generate the token
    static S4() {
        return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
    }

    public static UserTokenCreate() {
        const now = (new Date()).toISOString().slice(0, 19).replace(/-|:|T/g, "");
        return Helpers.S4() + now + Helpers.S4() + Helpers.S4();
    }

    public static Languages() {
        return [
            { id: 1, code: 'es', name: 'Español', flag: '/manager/flags/es.svg' },
            { id: 2, code: 'en', name: 'English', flag: '/manager/flags/en.svg' }
        ];
    }

    public static Number2Digit(n: number) {
        return Math.round(n * 100) / 100;
    }

    public static Number3Digit(n: number) {
        return Math.round(n * 1000) / 1000;
    }

    public static DateToday() {
        return (new Date()).getDate();
    }
    public static DateShortFormat(): string {
        let day = new Date();
        return `${day.getFullYear()}-${day.getMonth() + 1}-${day.getDate()}`;
    }
    public static DateFromDayString(day: string) {
        return (new Date(day + 'T00:00:00Z')).getDate();
    }
    public static DateCurrentGreatThanSeconds(dateLast: number, seconds: number) {
        const v = (new Date().getTime()) - dateLast;
        return v > (seconds * 1000)
    }

    public static UserGenerateQRData(userData: UserDataModel) {
        let data: any = {
            userId: userData.user.id,
            userCode: userData.user.code,
            createdAt: new Date()
        };
        return JSON.stringify(data)
    }

    public static ScheduleIsOpen(schedule: any): boolean {
        if (!schedule) return false;
        try{
            const now = new Date();
            const key = 'd' + now.getDay();
            const keyDay = now.getFullYear() + "-" + (now.getMonth() + 1) + "-" + now.getDate();
            const hour = (now.getHours() * 100) + now.getMinutes();
            if (schedule.exceptions && schedule.exceptions[keyDay]) {
                for (let x = 0; x < schedule.exceptions[keyDay].length; x++) {
                    const s = schedule.exceptions[keyDay][x][0].split(':');
                    const sH = (parseInt(s[0]) * 100) + parseInt(s[1]);
                    const e = schedule.exceptions[keyDay][x][1].split(':');
                    const eH = (parseInt(e[0]) * 100) + parseInt(e[1]);
                    if (sH < hour && eH > hour)
                        return true;
                }
            } else {
                if(schedule[key])
                    for (let x = 0; x < schedule[key].length; x++) {
                        const s = schedule[key][x][0].split(':');
                        const sH = (parseInt(s[0]) * 100) + parseInt(s[1]);
                        const e = schedule[key][x][1].split(':');
                        const eH = (parseInt(e[0]) * 100) + parseInt(e[1]);
                        if (sH < hour && eH > hour)
                            return true;
                    }
            }
        }catch(error:any){
            log.error('ScheduleIsOpen', error)
        }
        return false;
    }

    public static ScheduleOpenToday(schedule: any, closeTitle: string, scheduleTitle: string): string {
        if (!schedule) return ''
        try{
        const now = new Date();
        const key = 'd' + now.getDay();
        const keyDay = now.getFullYear() + "-" + (now.getMonth() + 1) + "-" + now.getDate();
        if (schedule.exceptions[keyDay]) {
            if (schedule.exceptions[keyDay].length > 1)
                return scheduleTitle + schedule.exceptions[keyDay][0][0] + '-' + schedule.exceptions[keyDay][0][1] + ' & ' + schedule.exceptions[keyDay][1][0] + '-' + schedule.exceptions[keyDay][1][1];
            else if (schedule.exceptions[keyDay].length > 0)
                return scheduleTitle + schedule.exceptions[keyDay][0][0] + '-' + schedule.exceptions[keyDay][0][1];
            else
                return closeTitle;
        }
        else {
            if (schedule[key].length > 1)
                return scheduleTitle + schedule[key][0][0] + '-' + schedule[key][0][1] + ' & ' + schedule[key][1][0] + '-' + schedule[key][1][1];
            else if (schedule[key].length > 0)
                return scheduleTitle + schedule[key][0][0] + '-' + schedule[key][0][1];
            else
                return closeTitle;
        }

        }catch(error:any){
            log.error('ScheduleOpenToday', error);
            return '';
        }
    }

    public static Schedule(schedule: any): any {
        if (!schedule) return ''
        let items: any[] = []
        for (let sch in schedule) {
            if(!schedule[sch]) continue;
            if (schedule[sch].length === 1)
                items.push(<li key={sch}><span>{dicNames[sch]}</span> {schedule[sch][0][0]}-{schedule[sch][0][1]}</li>)
            if (schedule[sch].length === 2)
                items.push(<li key={sch}><span>{dicNames[sch]}</span> {schedule[sch][0][0]}-{schedule[sch][0][1]} & {schedule[sch][1][0]}-{schedule[sch][1][1]}</li>)
        }
        return items;
    }
}




